/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/


console.log("==============");


if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};
/*===========================================================================
Cart free poup  
=============================================================================*/
var enable_free = 0;
var free_pro = $('body').data('free_true'); 
var free_enable = "false"; 
if(free_enable   && free_pro ){
  enable_free = 1;
}

if(enable_free == 1){

  var delay_popup = parseInt('40')*1000;
  
                         
  
  var after_days = parseInt('5');
  
                             

  function open_popup(){
//     if($.cookie("free_popup_open") != 'yes'){
//       console.log("open popup");
//       $('div[data-popup="cart-success"]').addClass('popup-active');
//       $('.overlay').addClass('popup-active');
//       $('body').addClass("popup__open");
//     }
  }
  
  function free_popup(){
//     console.log("free popup");
//     $.getJSON('/cart.json',function(data){
//       var total_price = data.total_price;
//       var all_ids = [];
//       var price = '9900';
//       var free_id = $('body').data("free_id");
//       if ( price == 0 ) price = 10000;
//       for(var i=0 ; i < data.items.length;i++){
//         all_ids.push(data.items[i].id);
//         console.log(all_ids[i]);
//       }
//       if(price <=  total_price){
//         $.get('/cart?view=free_popup',function(data){
//           $('.free_popup_section').html(data);
//         });
        
        
        
//         if(all_ids.indexOf(free_id) == -1 ){
//           console.log("sssss_open");
//           if($.removeCookie("free_popup_open", { path: '/' })){
//             open_popup();
//           }
//         }else{
//           $.cookie("free_popup_open","yes",{ expires: after_days , path: '/' });
//         }
        
      
//       }
//     });
  }
 // free_popup();
  
                         
                             
  /* free poup js */
//   $(window).on("load",function(){
//     if($.cookie("free_popup_open") != 'yes'){
//       setTimeout(function(){
//         open_popup();
//       },delay_popup);
//     }
//   });
//   $("body").on('click', ".close_free_popup", function(e){
//     e.preventDefault();
//     var $parents = $('.popup-active').attr('data-popup');
//     $(this).closest(".cs-popup").removeClass("popup-active");
//     $('.overlay').removeClass("popup-active");
//     $('body').removeClass("popup__open");
//     $.cookie("free_popup_open","yes",{ expires: after_days, path: '/' });
//   });
//   $("body").on('click', ".overlay", function(e){
//     e.preventDefault();
//     var $parents = $('.popup-active').attr('data-popup');
//     $('.cs-popup').removeClass('popup-active');
//     $('.overlay').removeClass("popup-active");
//     $('body').removeClass("popup__open");
//     $.cookie("free_popup_open","yes",{ expires: after_days, path: '/' });
//   });
  
  
}  
   /* free poup js end */

 
/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
//   alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  let gift_card_active = false;
    if($(form).find('.recipient_checkbox:checked').length > 0) {
        gift_card_active = true;
    }

    function isValidEmail(email) {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    }

    const properties = {};
    if (gift_card_active == true) {
        // const recipientEmail = $(form).find('input[name="properties[Recipient email]"]').val();
        // const recipientName = $(form).find('input[name="properties[Recipient name]"]').val();
        // const recipientMessage = $(form).find('textarea[name="properties[Message]"]').val();
        // const recipientSendOn = $(form).find('input[name="properties[Send on]"]').val();
        let errorMessage = "";

        // Email validation
        if ($(form).find('input[name="properties[Recipient email]"]').val().trim() === "") {
            errorMessage = "Email can't be blank.";
        } else {
            if (!isValidEmail($(form).find('input[name="properties[Recipient email]"]').val())) {
                errorMessage = "Invalid email format.";
            }
        }

        // If there is an error message, display it
        if (errorMessage !== "") {
            // Show the error container if hidden
            $('#RecipientForm-email-error-').removeClass('hidden');
            // Set the error message text
            document.getElementById("error-message").innerText = errorMessage;
            // Hide the error message after 5 seconds
            setTimeout(function () {
                document.getElementById("error-message").innerText = "";
                $('#RecipientForm-email-error-').addClass('hidden');
            }, 5000);
            return false;
        }

        // If no errors, set the properties
        properties["__shopify_send_gift_card_to_recipient"] = "on";
        properties["Recipient email"] = $(form).find('input[name="properties[Recipient email]"]').val() || "";
        properties["Recipient name"] = $(form).find('input[name="properties[Recipient name]"]').val() || "";
        properties["Message"] = $(form).find('textarea[name="properties[Message]"]').val() || "";
        properties["Send on"] = $(form).find('input[name="properties[Send on]"]').val() || "";
        
    }

    var productId = jQuery(form).find('input[name="id"]').val();
    var quantity = jQuery(form).find('input[name="quantity"]').val();
  console.log("properties",properties)
    const requestBody = {
        id: productId,
        quantity: quantity,
        properties: properties
    };

    // if (gift_card_active == true) {
    //     requestBody.properties = properties;
    // }
  console.log("form",requestBody)
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: requestBody,
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $.getJSON('/cart.js',function(data){
         if(data.item_count == 1){
          timerstart();
      }
    });
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
      const recipientForm = $(form).find('.recipient-form') // Ensure correct form selector
      // if (recipientForm) {
      // // Loop through input and textarea elements inside recipient-form
      // recipientForm.find('input, textarea').each(function() {
      //     var $input = $(this);
      //     if ($input.attr('type') === 'checkbox') {
      //         $input.prop('checked', false); // Uncheck the checkbox
      //     } else {
      //         $input.val(''); // Clear the input or textarea
      //     }
      // });
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      setTimeout(function() {
        $('.recipient-fields__field input, .recipient-fields__field textarea').val('');
        $('.recipient_checkbox').prop('checked', false);
      }, 2000);

    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector,$cartMoblieCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^=""]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      cartMoblieCountSelector : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartMoblieCountSelector = $(settings.cartMoblieCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    console.log('innn');
    
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector && $cartMoblieCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      $cartMoblieCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');
      
      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    console.log("sssssss");
//     if(enable_free == 1){
//       free_popup();
//     }
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      myClearFunction();
      $cartContainer
        .append('<p class="drawer-empty">' +  window.cart_general_empty + '</p>');
      cartCallback(cart);     
      return;
    }
    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    
    var price,price_cart_total,width,remaining_price,append_free_msg;
    
    
    price = parseFloat('5900');
    
    price_cart_total =  cart.total_price;
    if (price_cart_total < price){
      remaining_price = price - price_cart_total;
      width= ((price_cart_total * 100 )/price)+'%';
    } else{
      width = '100%';
    }
    if( price_cart_total >= price) {
      if (window.when_free_shipping_get_text != undefined){
      var get_msg = window.when_free_shipping_get_text
      append_free_msg = "<h6>"+get_msg +"</h6>";
      }
      else{
      append_free_msg = "<h6>Congratulations! You have got free shipping</h6>";
      }
    } else {
		if (window.free_shipping_text != undefined && window.free_shipping_text != ''){
          var price_re = "<strong>"+Shopify.formatMoney(remaining_price, settings.moneyFormat)+"</strong>";
          var msg = window.free_shipping_text;
    		append_free_msg="<h6>"+msg.replace('free_price',price_re)+"</h6>";
        } else {
        	append_free_msg="<h6>Only <strong>"+Shopify.formatMoney(remaining_price, settings.moneyFormat)+"</strong> away from free shipping.</h6>";
        }
	
    }
    
    
    
    
    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item);
    });

     // UPSELL START
    var fbtProducts = [];
    if (window.upsell_products.length > 0) {
        $.each(window.upsell_products, function(index, upsellItem) {
          var showUpsell = true;
          $.each(cart.items, function(index, item) {
            if (item.variant_id === upsellItem.variant_id) {
              showUpsell = false;
            }
          });
          if (fbtProducts.length < window.upsells_range && showUpsell) {
            var fbtProduct = {
              url: upsellItem.url,
              title: upsellItem.title,
              image: upsellItem.image,
              variant_id: upsellItem.variant_id,
              price: upsellItem.price,
              compare_at_price: upsellItem.compare_at_price,
            };
            fbtProducts.push(fbtProduct);
          }
        });
    }

    // UPSELL END

    // Gather all cart data and add to DOM
    data = {
      items: items,
      fbtProducts: fbtProducts,
      note: cart.note,
      append_free_msg: append_free_msg,
      width: width,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });

      // change position of AddToCart_free click event from here to our of this function 
      
    }
  };

  // Upsell  Ajax call Start
  $('body').on('click','.AddToCart_upsell',function(e){
        e.preventDefault();
        var btn = $(this);
        var id = $(this).data('id');
        var $body = $(document.body);
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: { "id":id, "quantity":1 },
          dataType: 'json',
          success: function(cart) {
            $body.addClass('drawer--is-loading');
            $('#CartCount').html(cart.item_count).removeClass('hidden-count');
            ShopifyAPI.getCart(cartUpdateCallback);

          },
          error: function(XMLHttpRequest, textStatus) {
            $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
            ShopifyAPI.onError(XMLHttpRequest, textStatus);
          }
        });
        setTimeout(function(){
          $('body').find('.close_free_popup').trigger("click");
        },1000);

      });
   // Upsell  Ajax call END
  
  $('body').on('click','.AddToCart_free',function(e){
        e.preventDefault();
        var btn = $(this);
        var id = $(this).data('id');
        var $body = $(document.body);
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: { "id":id, "quantity":1 },
          dataType: 'json',
          success: function(cart) {
            $body.addClass('drawer--is-loading');
            $('#CartCount').html(cart.item_count).removeClass('hidden-count');
            ShopifyAPI.getCart(cartUpdateCallback);

          },
          error: function(XMLHttpRequest, textStatus) {
            $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
            ShopifyAPI.onError(XMLHttpRequest, textStatus);
          }
        });
        setTimeout(function(){
          $('body').find('.close_free_popup').trigger("click");
        },1000);

      });

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
    qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));

// Start 5 minute timer js
$.getJSON('/cart.js',function(data){
  if(data.item_count >= 1){
    timerstart();
  }  
});
var sec = 0;
function pad ( val ) { return val > 9 ? val : "0" + val; }
var func;
function timerstart(){
  var timer2 = "5: 01";
  func = setInterval( function(){
    var timer = timer2.split(':');
    var minutes = parseInt(timer[0], 10);
    var seconds = parseInt(timer[1], 10);
    --seconds;
    minutes = (seconds < 0) ? --minutes : minutes;
    // if (minutes < 0) clearInterval(interval);
    seconds = (seconds < 0) ? 59 : seconds;
    seconds = (seconds < 10) ? '0' + seconds : seconds;  
    $("#seconds").html(seconds);
    $("#minutes").html(minutes);
    if (minutes <= 0 && seconds == 1 ) {
      timer2 = "5: 01";
    }
    else{      
      timer2 = minutes + ':' + seconds;
    }
  }, 1000);
}
function myStopFunction() {
  clearInterval(func);
}
function myClearFunction(){
  myStopFunction();
  $("#seconds").html(pad(00));
  $("#minutes").html(pad(00));
  sec = 0;
}
